import { render, staticRenderFns } from "./Sketch.vue?vue&type=template&id=5fa311de&scoped=true&"
import script from "./Sketch.vue?vue&type=script&lang=js&"
export * from "./Sketch.vue?vue&type=script&lang=js&"
import style0 from "./Sketch.vue?vue&type=style&index=0&id=5fa311de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa311de",
  null
  
)

export default component.exports